import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class WfUserEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  line_guid?: Optional<string> = Optional.empty();
  action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  id_user?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
}

export class WfUserEventCriteriaModelQuery {
  query = '';

  constructor(wfUserEventCriteriaModel: WfUserEventQueryCriteriaClass) {

    if (!wfUserEventCriteriaModel) {
      return;
    }

    this.query += wfUserEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += wfUserEventCriteriaModel.line_guid.filter(x => x !== '').map(x => '&line_guid=' + x).orElse('');
    this.query += wfUserEventCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');
    this.query += wfUserEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += wfUserEventCriteriaModel.id_user.filter(x => x !== '').map(x => '&id_user=' + x).orElse('');
    this.query += wfUserEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');

    this.query += '&status=' + wfUserEventCriteriaModel.status;
    this.query += '&orderBy=' + wfUserEventCriteriaModel.orderBy;
    this.query += '&order=' + wfUserEventCriteriaModel.order;
    this.query += '&offset=' + wfUserEventCriteriaModel.offset + '&limit=' + wfUserEventCriteriaModel.limit;
  }
}
